import { render, staticRenderFns } from "./LandingWatchParams.vue?vue&type=template&id=c2c85710&scoped=true&"
import script from "./LandingWatchParams.vue?vue&type=script&lang=js&"
export * from "./LandingWatchParams.vue?vue&type=script&lang=js&"
import style0 from "./LandingWatchParams.vue?vue&type=style&index=0&id=c2c85710&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c85710",
  null
  
)

export default component.exports